import { useGetOutreachServicesQuery } from 'services';

export const useConnectedServices = () => {
	return useGetOutreachServicesQuery(undefined, {
		selectFromResult: result => ({ ...result, data: result.data?.map(service => service.service) || [] })
	});
};
